import React, { useState, useEffect } from 'react';
import moment from 'moment/moment';
import LeaseApiService from '../../services/apiService';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { IoAdd } from "react-icons/io5";
import { GrDocumentUpdate } from "react-icons/gr";
import { MdOutlineRemoveCircleOutline } from "react-icons/md";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useLocation } from 'react-router-dom';

const AddLeaseAgrementView = () => {
    const apiService = new LeaseApiService();
    const [FilterTab, setFilterTab] = useState(true);
    const [tentantTab, setTanantTab] = useState(false);
    const [tentantJoint, setTanantJoint] = useState(false);
    const [unitRent, setUnitRent] = useState(true);
    const [rentCheck, setRentCheck] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const [dataList, setDataList] = useState([]);
    const [transectionData, transDetails] = useState([]);

    const location = useLocation();
    const itemData = location.state;
    useEffect(() => {
        getItems()
    }, [itemData]);

    const getItems = async () => {
        try {
            const validation = new URLSearchParams();
            validation.append('Action', 'GetLeaseLeaseDetailsByGroupId');
            validation.append('GroupId', itemData?.groupId);
            const validRes = await apiService.getApiParamater('GET_UNITNO_DATA', `?${validation.toString()}`);
            transDetails([validRes?.data?.result?.data])
            const listdata = new URLSearchParams();
            listdata.append('Action', 'GetLeaseAdditionalAmountByGroupId');
            listdata.append('GroupId', itemData?.groupId);
            const listres = await apiService.getApiParamater('GET_UNITNO_DATA', `?${listdata.toString()}`);

            setDataList(listres?.data?.result?.data)
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const [colDefs, setColDefs] = useState([
        { headerName: "Description", field: "Description", filter: true, floatingfilter: true, suppressMovable: true, width: 200, editable: false },
        { headerName: "Amount", field: "Amount", editable: false, suppressMovable: true, width: 150, editable: false },
        // { headerName: "Vat %", field: "VATPercent", filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
        { headerName: "Vat", field: "VAT", filter: true, floatingfilter: true, suppressMovable: true, width: 150, editable: false },
        // { headerName: "Vat Description", field: "VATDescription", filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
        { headerName: "Total", field: "Total", filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
        { headerName: "Posting", field: "Posting", filter: true, floatingfilter: true, suppressMovable: true, width: 150, editable: false },
        { headerName: "Cradit Account", field: "CrAcCode", filter: true, floatingfilter: true, suppressMovable: true, width: 200, editable: false },
        { headerName: "Cradit Account Name", field: "CrAcName", filter: true, floatingfilter: true, suppressMovable: true, width: 200, editable: false },
        { headerName: "Remarks", field: "Remarks", filter: true, editable: false, floatingfilter: true, suppressMovable: true, width: 200, editable: false },
        { headerName: "Deposit", field: "IsDeposit", filter: true, floatingfilter: true, suppressMovable: true, width: 200, editable: false },
    ]);

    const totalRent = transectionData.reduce((sum, row) => sum + (parseFloat(row?.Rent) || 0), 0)
    const totalVat = transectionData.reduce((sum, row) => sum + (parseFloat(row?.VAT) || 0), 0)
    const rentPerAnum = transectionData.reduce((sum, row) => sum + (parseFloat(row?.RentPerAnnum) || 0), 0)
    const totalDiscount = transectionData.reduce((sum, row) => sum + (parseFloat(row?.Discount) || 0), 0)
    const calculatedTotal = transectionData.reduce((sum, row) => sum + (parseFloat(row?.Total) || 0), 0)
    return (
        <div className="p-3">
            <div className='mb-3'><h6>Lease Agreement</h6></div>
            <div className='d-flex justify-content-between border-box2 p-3' style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills start overslid d-flex gap-4'>
                    <div
                        className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}
                    >
                        Transaction and Tenant
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}
                    >
                        Unit Details
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(2)}
                    >
                        Additional Charges
                    </div>
                </div>
                <div className='col-lg-4 d-flex gap-1'>
                    <div className='mainbtnSecondary flex-end gap-2 w-50'>
                        <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Back</div>
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setFilterTab(!FilterTab)}>
                            <div className='param-label pt-1'>Transaction Details</div>
                        </div>
                        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                                <div className="form-group grid-contain ">
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Transaction Date</label>
                                        <input type="date" className="p-2 form-control w-75" name="TransactionDate"
                                            value={moment(transectionData[0]?.TransactionDate).format("YYYY-MM-DD")} disabled />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Period From</label>
                                        <input type="date" className="p-2 form-control w-75" name="periodfrom"
                                            value={moment(transectionData[0]?.Lease_Date).format("YYYY-MM-DD")} disabled />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Period To</label>
                                        <input type="date" className="p-2 form-control w-75" name="periodto"
                                            value={moment(transectionData[0]?.Lease_Expiry).format("YYYY-MM-DD")} disabled />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Lease Term</label>
                                        <input type="text" className="p-2 form-control w-75" name="leaseTerm" disabled
                                            value={transectionData[0]?.LeaseTerm} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">No. Of Installments</label>
                                        <input type="number" className="p-2 form-control w-75" name="installments" disabled
                                            value={transectionData[0]?.PaymentTermNoOfChqs} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Select Remarks</label>
                                        <input type="text" className="p-2 form-control w-75" name="installments" disabled
                                            value={transectionData[0]?.Remarks} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Remarks</label>
                                        <input type="text" className="p-2 form-control w-75" value={transectionData[0]?.Remarks} name="remarks" disabled />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Arabic Remarks</label>
                                        <input type="text" className="p-2 form-control w-75" name="arabicRemarks"
                                            value={transectionData[0]?.RentPI_Remarks} disabled />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setTanantTab(!tentantTab)}>
                            <div className='param-label pt-1'>Tenant Primary Details</div>
                        </div>
                        <div className={`slide-content ${tentantTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${tentantTab ? 'slide-in' : 'slide-out'}`}>
                                <div className="form-group grid-contain ">
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant Name</label>
                                        <input type="text" className="p-2 form-control w-75" name="installments" disabled
                                            value={dataList[0]?.TenantName} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant No</label>
                                        <input type="text" className="p-2 form-control w-75" name="installments" disabled
                                            value={dataList[0]?.TenantNo} />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                        <input type="number" value={dataList[0]?.TenantName} className="p-2 form-control w-75" name="periodto" disabled />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                        <input type="email" className="p-2 form-control w-75" name="leaseTerm" disabled />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Passport / ID</label>
                                        <input type="text" className="p-2 form-control w-75" name="installments" disabled />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                        <input type="text" className="p-2 form-control w-75" name="remarks" disabled />

                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Vat Reg No</label>
                                        <input type="text" className="p-2 form-control w-75" name="remarks" disabled />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Leasing Agent</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}

                                            menuPortalTarget={document.body}
                                            menuPlacement="auto"
                                            menuShouldScrollIntoView={false} isDisabled
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section my-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setTanantJoint(!tentantJoint)}>
                            <div className='param-label pt-1'>Tenant Joint Details</div>
                        </div>
                        <div className={`slide-content ${tentantJoint ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${tentantJoint ? 'slide-in' : 'slide-out'}`}>
                                <div className="form-group grid-contain ">
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant Name</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}

                                            menuPortalTarget={document.body}
                                            menuPlacement="auto"
                                            menuShouldScrollIntoView={false} isDisabled
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant No</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}

                                            menuPortalTarget={document.body}
                                            menuPlacement="auto"
                                            menuShouldScrollIntoView={false} isDisabled
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                        <input type="number" className="p-2 form-control w-75" name="periodto" disabled />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                        <input type="email" className="p-2 form-control w-75" name="leaseTerm" disabled />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Passport / ID</label>
                                        <input type="text" className="p-2 form-control w-75" name="installments" disabled />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                        <input type="text" className="p-2 form-control w-75" name="remarks" disabled />

                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Vat Reg No</label>
                                        <input type="text" className="p-2 form-control w-75" name="remarks" disabled />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Broker</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}

                                            menuPortalTarget={document.body}
                                            menuPlacement="auto"
                                            menuShouldScrollIntoView={false} isDisabled
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {gridVisibility[1] && (
                <div>
                    <div className='table-container my-3' style={{ overflowX: 'auto', height: "400px" }}>
                        <table>
                            <thead className='dynoTable'>
                                <tr>
                                    <th>Action</th>
                                    <th>Property</th>
                                    <th>Unit No.</th>
                                    <th>Unit Ref No.</th>
                                    <th>Unit Class</th>
                                    <th>Area</th>
                                    <th>Discount</th>
                                    <th>Tax</th>
                                    <th>Rent</th>
                                    <th>VAT</th>
                                    <th>Total</th>
                                    <th>Rent Per Anum</th>
                                    <th>Bed Room’s</th>
                                    <th>Unit Type</th>
                                    <th>Unit Category</th>
                                    <th>Parking No</th>
                                    <th>Munc A/c No.</th>
                                    <th>Munc No. Community</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(transectionData) && transectionData?.map((data, index) => (
                                    <tr key={index}>
                                        <td className='m-0 p-0'> <input className='p-1' type="checkbox" disabled style={{ width: "80px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.Property_Name || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.Unit_No || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.UnitRefNo || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.UnitClass || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.Total_Area || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.Discount || "0"} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.Tax || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.Rent || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.VAT || "0"} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.Total || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.RentPerAnnum || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.Bedrooms || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.Unit_Type || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.Unit_Category || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.ParkingNo || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.municipalityNo || ""} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data.MuncAcNo || ""} disabled /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className='d-flex justify-content-between boxs'>
                        <div className='d-flex gap-2'>
                            <div className="totalhead center">Total Units</div>
                            <div className='field'>{transectionData?.length || "---"}</div>
                        </div>
                        <div className='d-flex gap-2'>
                            <div className="totalhead center">Discount</div>
                            <div className='field'>{`${totalDiscount}` || "---"}</div>
                        </div>
                        <div className='d-flex gap-2'>
                            <div className="totalhead center">Vat Total</div>
                            <div className='field'>{totalVat || "---"}</div>
                        </div>
                        <div className='d-flex gap-2'>
                            <div className="totalhead center">Rent Total</div>
                            <div className='field'>{totalRent || "---"}</div>
                        </div>
                        <div className='d-flex gap-2'>
                            <div className="totalhead center">Total Amount</div>
                            <div className='field'>{calculatedTotal || "---"}</div>
                        </div>
                        <div className='d-flex gap-2'>
                            <div className="totalhead center">Rent Per Anum Total</div>
                            <div className='field'>{rentPerAnum || "---"}</div>
                        </div>
                    </div>
                </div>
            )}
            {gridVisibility[2] && (
                <div>
                    <div className="ag-theme-quartz" style={{ height: 500, suppressMovable: true, width: '100%' }}>
                        <AgGridReact
                            columnDefs={colDefs}
                            rowData={dataList}
                            suppressRowClickSelection={true}
                            getRowStyle={(params) => {
                                return params.node.rowIndex % 2 === 0
                                    ? { background: '#F0EDF5' }
                                    : { background: '#fff' };
                            }}
                        />
                    </div>
                </div>
            )}

        </div>

    );
};
export default AddLeaseAgrementView;
